import { AssetSettings as OldAssetSettings } from "@models/tradable/split/asset_settings";

export interface TradableSettings {
	readonly id: string;
	readonly isAvailable: boolean;
	readonly isBuyActive: boolean;
	readonly isDepositActive: boolean;
	readonly isIndexOnly: boolean;
	readonly isMaintenanceEnabled: boolean;
	readonly minBuyEur: number;
	readonly minSellEur: number;
	readonly isSellActive: boolean;
	readonly sort: number;
	readonly isTransferActive: boolean;
	readonly walletMinDeposit: number;
	readonly walletSmallDeposit: number;
	readonly walletSmallDepositFee: number;
	readonly isWithdrawActive: boolean;
	readonly isPriceOrderAvailable: boolean;
}

export class TradableSettingsAdapter {
	public adapt(settings: OldAssetSettings): TradableSettings {
		return {
			id: settings.getId(),
			isAvailable: settings.isAvailable(),
			isBuyActive: settings.isBuyActive(),
			isDepositActive: settings.isDepositActive(),
			isIndexOnly: settings.isIndexOnly(),
			isMaintenanceEnabled: settings.isMaintenance(),
			minBuyEur: settings.getMinBuy(),
			minSellEur: settings.getMinSell(),
			isSellActive: settings.isSellActive(),
			sort: settings.getSort(),
			isTransferActive: settings.isTransferActive(),
			walletMinDeposit: settings.getWalletMinDeposit(),
			walletSmallDeposit: settings.getSmallDeposit(),
			walletSmallDepositFee: settings.getSmallDepositFee(),
			isWithdrawActive: settings.isWithdrawActive(),
			isPriceOrderAvailable: settings.isPriceOrderAvailable()
		};
	}
}
